<template>
  <div class="personal-settings">
    <SettingsPersonalTime />
    <br>
    <h3 class="subtitle" id="templates">{{$t("settings.personal.timeTemplates")}}</h3>
    <table class="table is-narrow">
      <thead>
        <tr>
          <th>{{$t("settings.personal.day")}}</th>
          <th>{{$t("settings.personal.project")}}</th>
          <th>{{$t("settings.personal.hours")}}</th>
          <th></th>
        </tr>
      </thead>
      <tfoot>
        <tr>
          <th>
            <span class="tag">{{sumAllTimeTemplate(rowHours)}}</span>
          </th>
          <th>                    
            <p class="buttons">
                <a @click="enableFields = true" v-if="!enableFields" class="button is-small is-info">
                    <span class="icon">
                        <font-awesome-icon icon="pencil-alt"></font-awesome-icon>
                    </span>
                    {{$t("input.edit")}}
                </a>
                <a @click="updateTimeTemplate()" v-if="enableFields" class="button is-small is-primary">
                    <span class="icon">
                        <font-awesome-icon icon="check"></font-awesome-icon>
                    </span>
                    {{$t("input.save")}}
                </a>
                <a @click="enableFields = false" v-if="enableFields" class="button is-small is-danger">
                    <span class="icon">
                        <font-awesome-icon icon="times"></font-awesome-icon>
                    </span>
                      {{$t("input.cancel")}}
                </a>
                <a @click="deleteTimeTemplate()" v-if="enableFields" class="button is-small is-warning is-pulled-right">
                    <span class="icon">
                        <font-awesome-icon :icon="['far', 'trash-alt']"></font-awesome-icon>
                    </span>
                      {{$t("input.delete")}}
                </a>
            </p>
          </th>
          <th></th>
          <th></th>
        </tr>
      </tfoot>
      <tbody>
        <tr v-for="day in [1,2,3,4,5,6,7]" :key="day">
          <td class="day-name">
            {{returnDayName(day)}}
            <br>
            <span class="tag">{{sumTimeTemplate(day, rowDays, rowHours)}}</span>
          </td>
          <td>
            <div class="field">
              <div class="control">
                <multiselect
                  v-model="templateProjects[day]" 
                  class="is-small"
                  :options="projectInput"
                  group-values="task"
                  group-label="no"
                  :placeholder="$t('input.choose')"
                  track-by="task_no"
                  label="description"
                  :select-label="$t('input.choose')"
                  :deselect-label="$t('input.remove')"
                  :disabled="!enableFields">
                  <span slot="noResult">{{$t('input.noProjectFound')}}</span>
                </multiselect>
              </div>
            </div>
            <div v-for="(row, index) in rowDays" v-if="row == day" v-bind:key="index" class="field">
              <div class="control">
                 <multiselect
                  v-model="templateProjects[day][index]" 
                  class="is-small"
                  :options="projectInput"
                  group-values="task"
                  group-label="no"
                  :placeholder="$t('input.choose')"
                  track-by="task_no"
                  label="description"
                  :select-label="$t('input.choose')"
                  :deselect-label="$t('input.remove')"
                  :disabled="!enableFields">
                  <span slot="noResult">{{$t('input.noProjectFound')}}</span>
                </multiselect>
              </div>
            </div>
          </td>
          <td>
              <input class="input" type="number" v-model.number="hours[day]" :disabled="!enableFields">
              <div v-for="(row, index) in rowDays" v-if="row == day && templateProjects[day][index]" v-bind:key="index">
                <input class="input" type="number" v-model.number="rowHours[index]" :disabled="!enableFields" style="margin-top:18px;width:80%">
                <a @click="removeRow(index, day)" style="vertical-align: bottom; margin-left:0.5em" v-if="enableFields">
                  <font-awesome-icon icon="minus"></font-awesome-icon>
                </a>
              </div>
          </td>
          <td>
            <span class="icon" v-if="templateProjects[day] && timeTemplate.hours" style="padding-top: 1em;">
              <a @click="addRow(day)" v-if="enableFields">
                <font-awesome-icon icon="plus"></font-awesome-icon>
              </a>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- <h3 class="subtitle" id="projects">{{$t("settings.personal.favProjects")}}</h3>
    <table class="table is-fullwidth">
      <thead>
        <tr>
          <th>{{$t("settings.project")}}</th>
          <th>{{$t("settings.projectLine")}}</th>
        </tr>
      </thead>
      <tfoot>
        <tr>
          <th></th>
          <th></th>
        </tr>
      </tfoot>
      <tbody>
        <tr v-for="project in returnProjects" :key="project['.key']">
          <td>
             <span v-if="orgSettings.ERPenabled">{{ project.description }} ({{ project.no }})</span>
             <span v-else>{{ project.name }}</span>              
          </td>
          <td>
            <div class="control" v-for="line in customProjectLines" v-if="!orgSettings.ERPenabled && line.project == project['.key']" :key="line['.key']">
              <div class="columns">
                <div class="column">
                 {{ line.name }}
                </div>
                <div class="column is-4">
                  <SettingsFavInput :line="line" :isCustom="!orgSettings.ERPenabled"></SettingsFavInput>
                </div>
              </div>              
            </div>
            <div class="control" v-for="line in orgProjectLines" v-if="orgSettings.ERPenabled && line.no == project.no" :key="line['.key']">
              <div class="columns">
                <div class="column">
                 {{ line.description }} ({{ line.task_no }})
                </div>
                <div class="column is-4">
                  <SettingsFavInput :line="line"></SettingsFavInput>
                </div>
              </div>              
            </div>
          </td>
        </tr>
      </tbody>
    </table> -->
  </div>
</template>

<script>
import firebase from '@/firebase'
import moment from 'moment'
import _ from 'lodash'
import Multiselect from 'vue-multiselect'
import SettingsFavInput from '@/components/settings/SettingsFavInput.vue'
import SettingsPersonalTime from '@/components/settings/SettingsPersonalTime.vue'

export default {
  name: 'SettingsUser',
  components: {
    SettingsFavInput,
    SettingsPersonalTime,
    Multiselect,
  },
  props: {
  },
  data: function() {
    return {
      myProjects: {},
      templateProjects: [],
      hours: [0,0,0,0,0,0,0,0],
      rowHours: [],
      rowDays: [],
      enableFields: false,
      error: false,
    }
  },
  watch: {
    '$route' (to, from) {
        if(to.params.nav2 === 'templates') {
          this.$scrollTo('#templates')
        }
    }
  },
  firebase: function() { 
    const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
    const userid = JSON.parse(localStorage.getItem('profile')).user_id;
    return {
        orgSettings: {
          source: firebase.database().ref('/organisations/' + tenantid + '/settings'),
          asObject: true
        },
        timeTemplate: {
            source: firebase.database().ref('/organisations/' + tenantid + '/userPreferences/' + userid + '/timeTemplate'),
            asObject: true,
            readyCallback() {
              if(this.timeTemplate && this.timeTemplate.hours) {
                this.hours = this.timeTemplate.hours
              }
              if(this.timeTemplate && this.timeTemplate.projects) {
                this.templateProjects = this.timeTemplate.projects
              }
              if(this.timeTemplate && this.timeTemplate.rowDays) {
                this.rowDays = this.timeTemplate.rowDays
              }
              if(this.timeTemplate && this.timeTemplate.rowHours) {
                this.rowHours = this.timeTemplate.rowHours
              }
            }
        },
        customProjects: {
          source: firebase.database().ref('/organisations/' + tenantid + '/settings/customProjects'),
        },
        customProjectLines: {
          source: firebase.database().ref('/organisations/' + tenantid + '/settings/customProjectLines'),
        },
        myProjects: {
            source: firebase.database().ref('/organisations/' + tenantid + '/JobList'),
        },
        orgProjectLines: {
            source: firebase.database().ref('/organisations/' + tenantid + '/JobTaskLines'),
        },
        myProjectLines: {
            source: firebase.database().ref('/organisations/' + tenantid + '/userPreferences/' + userid + '/JobTaskLines')
        }
    }
  },
  computed: {
    projectInput() {
          if(!this.orgSettings.ERPenabled) {
            return this.groupCustomProjects;
          } else {
            return this.groupProjectLines
          }
      },
      groupCustomProjects() {
        if(!this.orgSettings.ERPenabled) {
          const self = this;
          let groupedProjectsArray = []
          groupedProjectsArray = _.map(this.orgSettings.customProjects, function(project,pkey) {
            return {
              key: pkey,
              no: project.name,
              task: _.without(_.map(self.orgSettings.customProjectLines, function(line, plkey) {
                if(pkey === line.project) {
                  return {
                    no: pkey,
                    task_no: plkey,
                    description: line.name
                  }
                } else {
                  return null;
                }
              }), null)
            }
          })
          return groupedProjectsArray
        } else {
          return null;
        }
      },
      groupProjectLines: function() {
          // merge all project tasks with favorites if project & task is fav
          function mergeByJob(objValue, srcValue, key, object, source, stack){
            if (object.Job_No == source.Job_No && object.Job_Task_No == source.Job_Task_No) {
              // console.log("key: ", key)
              // console.log("object: ", object.Job_No)
              _.merge(objValue, {favorite: true});
            }
          }
          _.mergeWith(this.orgProjectLines, this.allProjectLinesFavorites, mergeByJob);
          // set variable for description search
          var desc = this.orgProjectLines;
          // set variable for project description substitution
          var projects = this.orgProjects;
          var result = _.chain(this.orgProjectLines).groupBy("no").map(function(v, i) {
            return {
              // find project description
              no: _.get(_.find(projects, {'no': i}), 'description') + ' (' + i + ')', //i,
              task:
                _.chain(v).groupBy("task_no").map(function(v2, i2) {
                  // if favorite add star to description
                  var fav = '';
                  if (_.get(_.find(v2, 'favorite'), 'favorite') == true) {
                    fav = '★ '
                  }
                  return {
                    no: i,
                    task_no: i2,
                    description: fav + _.get(_.find(desc, {'no': i, 'task_no': i2}), 'description') + ' (' + i2 + ')',
                  }
              }).value()
            }
          }).value();
          // reverse in order to get favorites first TODO fix sort order
          return result;
    },
    returnProjects() {
      if(this.orgSettings.ERPenabled) {
        return this.myProjects
      } else {
        return this.customProjects
      }
    }
  }, 
  methods: {
    addRow(day) {
      this.rowDays.push(day)
    },
    removeRow(index, day) {
      this.$delete(this.rowDays, index)
      this.$delete(this.rowHours, index)
      this.$delete(this.templateProjects[day], index)
    },
    sumAllTimeTemplate(hours) {
      if(this.timeTemplate.hours) {
        return _.sum(this.timeTemplate.hours) + _.sum(hours);
      } else {
        return 0;
      }
    },
    sumTimeTemplate(day, rows, hours) {
      if(this.timeTemplate.hours) {
        const stdHours = this.timeTemplate.hours[day]
        let keys = [];
        rows.filter(function(elem, index, array){
            if(elem == day) {
                keys.push(index);
            }
        });
        let sum = 0;
        for (var i = 0; i < hours.length; i++) {
          if(keys.indexOf(i) >= 0) {
            sum += hours[i]
          }
        }
        return sum + stdHours || 0;
      } else {
        return 0;
      }
    },
    deleteTimeTemplate() {
      try {
        this.$firebaseRefs.timeTemplate.remove()
        this.templateProjects = []
        this.rowHours = []
        this.rowDays = []
        this.hours = [0,0,0,0,0,0,0,0]
        this.enableFields = false
      } catch(error) {
        this.error = error;
      } finally {
          if(!this.error) {
            this.$snotify.success(this.$i18n.t('messages.timeTemplateDeleted'), {
            showProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true
            });
          } else {
            this.$snotify.warning(this.$i18n.t('messages.errorMessage'), {
              showProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true
            });  
          }
      }
    },
    updateTimeTemplate() {
      try {
        this.$firebaseRefs.timeTemplate.child('/projects/').set(this.templateProjects)
        this.$firebaseRefs.timeTemplate.child('/hours/').set(this.hours)
        this.$firebaseRefs.timeTemplate.child('/rowDays/').set(this.rowDays)
        this.$firebaseRefs.timeTemplate.child('/rowHours/').set(this.rowHours)
      } catch(error) {
        this.error = error
      } finally {
        if(!this.error) {
            this.enableFields = false
            this.$snotify.success(this.$i18n.t('messages.infoSaved'), {
            showProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true
            });
        } else {
              this.$snotify.warning(this.$i18n.t('messages.errorMessage'), {
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true
              }); 
        }
      }
    },
    returnDayName(day) {
      moment.locale(this.$i18n.locale)
      return moment().isoWeekday(day).format("dddd")
    },
    updateFavorite: function(key, fav, line) {
      //set fav to true or false
      this.$firebaseRefs.myProjectLines.child(key).update({'favorite': fav, 'Job_No': line.no, 'Job_Task_No': line.task_no});
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.day-name {
  text-transform:capitalize;
}
</style>
